import VueI18n from 'vue-i18n'
import Vue from 'vue'
import en from './en.json'
import zh_CN from './zh_cn.json'
import zh_TW from './zh_TW.json'
import { LanguageContent } from '@/lib/util/lang.js'

let now_language = handleLocalStorage('get', 'paas_language')

export function setI18nLocale(language) {
    i18n.locale = LanguageContent.getI18nLocaleByPaaSJsonSuffix(language)
}

export function resetI18nLocale() {
    handleLocalStorage('remove', 'language')
    handleLocalStorage('remove', 'paas_language')
    i18n.locale = 'zh_CN'
}

export function setLanguageLocalStorage(language) {
    switch (language) {
        case 'zh':
            handleLocalStorage('set', 'language', 'zh_CN')
            break
        case 'cht':
            handleLocalStorage('set', 'language', 'zh_TW')
            break
        default:
            handleLocalStorage('set', 'language', 'en')
    }
}

export function setPaasLanguageLocalStorage(language) {
    const val = LanguageContent.getI18nLocaleByPaaSJsonSuffix(language)
    handleLocalStorage('set', 'paas_language', val)
}

export function handleLocalStorage(method, key, value) {
    switch (method) {
        case 'get': {
            let temp = window.localStorage.getItem(key);
            if (temp) {
                return temp
            } else {
                return false
            }
        }
        case 'set': {
            window.localStorage.setItem(key, value);
            break
        }
        case 'remove': {
            window.localStorage.removeItem(key);
            break
        }
        default: {
            return false
        }
    }
}

if(!now_language){
    now_language = 'zh_CN'
}

Vue.use(VueI18n)
export const i18n = new VueI18n({
    locale: now_language,
    fallbackLocale: 'en',
    messages: { en, zh_CN, zh_TW }
})


// WEBPACK FOOTER //
// ./src/i18n/index.js